export default __webpack_public_path__ + "static/khadiga-b3ab6733244add658b2dffb774e25966.jpg";